import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import { AuthService } from 'modules/core/services/auth.service';


@Injectable()
export class LoggedGuard implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router) { }

  canActivate(): Observable<boolean> {
    return this.authService.getUser(true)
      .pipe(
        switchMap(user => {
          if (user) {
            this.router.navigateByUrl('dashboard');
            return of(false);
          } else {
            return of(true);
          }
        }),
        catchError(() => {
          return of(true);
        })
      );
  }
}
